/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: RegisterForm.tsx
 * Project: mle-client
 * Committed last: 2021/11/2 @ 177
 * ---
 */

import { Form, Formik }           from 'formik';
import React                      from 'react';
import * as Yup                   from 'yup';
import { defaultRequiredMessage } from '../../config/content';
import { Button }                 from '@blueprintjs/core';
import { BpTextFieldWrapper }     from './wrappers/BpTextFieldWrapper';
import { DefaultFormProps }       from '../../common/interfaces';

const RegisterFormValidationSchema = Yup.object().shape({
  email: Yup.string().email().required(defaultRequiredMessage),
});

export interface ResetMailFormData {
  email: string;
}

export const ResetMailForm = (props: DefaultFormProps) => {
  return (
    <Formik
      initialValues={ {} as ResetMailFormData }
      validationSchema={ RegisterFormValidationSchema }
      onSubmit={ props.onSubmit }
    >
      { ({}) => (
        <Form>
          <div className="mle-form-row"></div>
          <BpTextFieldWrapper name="email" label="Indirizzo e-mail" type="email"
                              required placeholder="mario.rossi@gmail.com"/>
          <div className="mle-form-submit">
            <Button intent="primary" type="submit" className="w-full">
              Invia link alla mail
            </Button>
          </div>
        </Form>
      ) }
    </Formik>
  );
};
